import React from 'react';
import PropTypes from 'prop-types';
import classes from './style.module.scss';

export default function Error({ message }) {
  return <div className={classes.container}>{message}</div>;
}

Error.propTypes = {
  message: PropTypes.string,
};

Error.defaultProps = {
  message: 'Oops, Something Went Wrong...',
};
